import React from "react";
import {
  footerBgColor,
  borderFooterColor,
  titleFooter,
  linkFooter,
  textCompany,
  textDescrip,
  heightFooter,
} from "../components/ThemeConfig/footerConfig";
import { useFooterDynamicStyles } from "../components/useDynamic/footer_DynamicStyle";
function Footer() {
  useFooterDynamicStyles(footerBgColor, borderFooterColor, heightFooter);
  return (
    <footer className="main-footer">
      <strong>
        {titleFooter}&nbsp;
        <a href={linkFooter}>&nbsp;{textCompany}</a>.
      </strong>
      &nbsp;{textDescrip}
      <div className="float-right d-none d-sm-inline-block">
        {/* <b>Version</b> 3.2.0 */}
      </div>
    </footer>
  );
}

export default Footer;
